module.exports = __webpack_public_path__ + "img/thumbnail_GiantPanda_m_albino.848e5ebe.png";